// extracted by mini-css-extract-plugin
export default {"container":"BillingStatusBox_container__3W1Nt","content":"BillingStatusBox_content__TkOa1","box":"BillingStatusBox_box__n4gt4"};